import React from "react";
import "./App.css";
import "bootstrap";
import { BrowserRouter } from "react-router-dom";
import NavBar from "./Components/NavBar";
import Router from "./Components/Router";
import Footer from "./Components/Footer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <NavBar />
        <main className="site-main">
          <Router />
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
